import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) =>
	`.participant-signature-modal-reason-label {
  color: ${dt('participantSignatureModal.reasonLabel.color')};
  font-size: ${dt('participantSignatureModal.reasonLabel.fontSize')};
  font-weight: ${dt('participantSignatureModal.reasonLabel.fontWeight')};
}`;
